function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "./dashboard.css";
import { useSortBy, useTable } from "react-table";
import { HiOutlineSelector, HiChevronDown, HiChevronUp } from "react-icons/hi";
import TopAppsAndWebsites from "./TopAppsAndWebsites";
import moment from "moment-timezone";
import Loader from "./../Loader/Loader";
import Profile from "../img/profile/little-girl.png";
import { FilterContext, UserContext } from "../index";
import { OVERVIEW_DATA_QUERY, OVERVIEW_USER_WORK_DETAILS_QUERY, UPDATE_GST_NUMBER_MUTATION, OVERVIEW_UPCOMING_DETAILS_QUERY, OVERVIEW_CURRENTLY_USING_DATA_QUERY, OVERVIEW_WORKED_HOUR_USING_DATA_QUERY } from "./query";
import { arrayToStringOutput } from "./../SideMenu/Header";
import WorkLoadAnalysisData from "./WorkLoadAnalysis";
import { LateClockInDetails, AbsentDetails, UpcoimgHolidays, UpcomingLeaves } from "./AttendanceDetails";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form, Formik } from "formik";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { convertOrganisationTimezoneForfilterDate } from "../ViewLeave/ViewLeave";
import { BillingDueExtendedMsg, BillingBankTrasferPlanEndBeforeMsg } from "./../Billing/Billing";
import { AiFillInfoCircle } from "react-icons/ai";
import { Container } from "react-bootstrap";
import { MdClose } from "react-icons/md";
var CURRENTLY_LIMIT = 15;
var WORK_HOUR_LIMIT = 15;
var Dashboard = function Dashboard(props) {
  var _user$organisations$, _user$organisations, _organisationDetails$, _teamDetails$role, _overViewData$overvie, _overViewData$overvie2, _overviewUserWorkDeta, _overviewUserWorkDeta2, _upcomingLeaveDetails, _upcomingLeaveDetails2;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    startDate = _React$useContext2.startDate,
    endDate = _React$useContext2.endDate,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationUserCount = _React$useContext2.organisationUserCount,
    organisationBilling = _React$useContext2.organisationBilling,
    filterRole = _React$useContext2.role,
    from = _React$useContext2.from,
    leaveSettingsUser = _React$useContext2.leaveSettingsUser,
    organisationStatus = _React$useContext2.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  /* if user onboard process incomplete 
  that time navigate to onboarding page */
  if ((user === null || user === void 0 ? void 0 : (_user$organisations$ = user.organisations[0]) === null || _user$organisations$ === void 0 ? void 0 : _user$organisations$.userOnboardStatus) === "Onboard Process Incompleted") {
    props === null || props === void 0 ? void 0 : props.history.push({
      pathname: "/on-boarding/".concat(organisationBilling.planName),
      state: {
        from: "dashboard"
      }
    });
    return null;
  }
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    overviewUserDataFetch = _React$useState2[0],
    setOverviewUserDataFetch = _React$useState2[1];
  React.useEffect(function () {
    if (from == "web" && filterRole == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [filterRole]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && filterRole != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);

  // React.useEffect(() => {
  //   if (filterRole == "Member") {
  //     props?.history.push("/task-tracker");
  //   }
  // }, [filterRole]);

  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var organisationDetails = (user === null || user === void 0 ? void 0 : (_user$organisations = user.organisations) === null || _user$organisations === void 0 ? void 0 : _user$organisations.find(function (organisation) {
    return organisation.id === organisationId;
  })) || {};
  var teamDetails = (organisationDetails === null || organisationDetails === void 0 ? void 0 : (_organisationDetails$ = organisationDetails.teams) === null || _organisationDetails$ === void 0 ? void 0 : _organisationDetails$.find(function (team) {
    return team.id === teamId;
  })) || {};
  var role = teamDetails === null || teamDetails === void 0 ? void 0 : (_teamDetails$role = teamDetails.role) === null || _teamDetails$role === void 0 ? void 0 : _teamDetails$role.roleName;
  var _useQuery = useQuery(OVERVIEW_DATA_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: filterRole,
        dateString: dateFilter,
        projectSettings: organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagementFeature ? organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.projectManagementFeature : false
      },
      skip: !teamId || !organisationId
    }),
    overViewData = _useQuery.data,
    overViewError = _useQuery.error,
    overViewLoading = _useQuery.loading,
    refetch = _useQuery.refetch,
    subscribeToMore = _useQuery.subscribeToMore;
  var _useLazyQuery = useLazyQuery(OVERVIEW_USER_WORK_DETAILS_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: filterRole,
        dateString: dateFilter,
        planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
      },
      fetchPolicy: "network-only",
      skip: !teamId && !organisationId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getUserWorkDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    overviewUserWorkDetailsData = _useLazyQuery2$.data,
    overviewUserWorkDetailsError = _useLazyQuery2$.error,
    overviewUserWorkDetailsLoading = _useLazyQuery2$.loading;
  var _useLazyQuery3 = useLazyQuery(OVERVIEW_UPCOMING_DETAILS_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: filterRole
      },
      fetchPolicy: "network-only",
      skip: !teamId && !organisationId
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getUpcomingLeaveDetails = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    upcomingLeaveDetailsData = _useLazyQuery4$.data,
    upcomingLeaveDetailsError = _useLazyQuery4$.error,
    upcomingLeaveDetailsLoading = _useLazyQuery4$.loading;
  React.useEffect(function () {
    if (overViewLoading || overViewError) return;
    if (!overViewData) return;
    if (!overViewLoading && overViewData !== null && overViewData !== void 0 && overViewData.overviewData && overviewUserDataFetch) {
      getUserWorkDetails();
    }
  }, [overViewData === null || overViewData === void 0 ? void 0 : overViewData.overviewData]);
  React.useEffect(function () {
    if (overviewUserWorkDetailsLoading || overviewUserWorkDetailsError) return;
    if (!overviewUserWorkDetailsData) return;
    if (!overviewUserWorkDetailsLoading && overviewUserWorkDetailsData !== null && overviewUserWorkDetailsData !== void 0 && overviewUserWorkDetailsData.overviewUserWorkDetails) {
      getUpcomingLeaveDetails();
    }
  }, [overviewUserWorkDetailsData === null || overviewUserWorkDetailsData === void 0 ? void 0 : overviewUserWorkDetailsData.overviewUserWorkDetails]);

  // console.log({
  //   upcomingLeaveDetailsData: upcomingLeaveDetailsData?.overviewUpcomingDetails,
  //   upcomingLeaveDetailsLoading,
  // });

  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
    setOverviewUserDataFetch(true);
  }, [props.location.key]);
  if (overViewLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (overViewError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!overViewData) {
    return null;
  }
  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  var currentSystemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var organisationSystemOffset = organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.organisationTimezone ? moment.tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).utcOffset() : 0;
  var currentSystemDate = moment().tz(currentSystemTimezone).format("MMMM DD");
  var orgTimezoneDate = moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("MMMM DD");
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-root"
  }, role != "Member" ? /*#__PURE__*/React.createElement(BillingDueExtendedMsg, {
    failedPlanEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.failedPlanEnd,
    billingPeriodEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.billingPeriodEnd,
    handleCheckout: null,
    pageName: "dashboard",
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : null, role != "Member" ? /*#__PURE__*/React.createElement(BillingBankTrasferPlanEndBeforeMsg, {
    beforePlanEndAlert: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.beforePlanEndAlert,
    planEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planEnd,
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    paymentType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType
  }) : null, /*#__PURE__*/React.createElement(NewProductCard, {
    planName: organisationBilling.planName,
    isTrial: organisationBilling.isTrial
  }), dateFilter == "Today" && currentSystemDate != orgTimezoneDate ? /*#__PURE__*/React.createElement(WarningCardOrgTimezone, {
    currentSystemDate: currentSystemDate,
    orgTimezoneDate: orgTimezoneDate,
    currentSystemTimezone: currentSystemTimezone,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }) : null, /*#__PURE__*/React.createElement(WorkSummary, {
    overviewSummary: overViewData.overviewData.teamWorkSummary,
    pageComponent: overViewData.overviewData.pageComponent,
    organisationUserCount: organisationUserCount,
    dateFilter: dateFilter,
    startDate: startDate
  }), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-charts "
  }, " ", dateFilter == "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? /*#__PURE__*/React.createElement(WorkLoadAnalysisData, {
    workLoadAnalysis: overViewData.overviewData.workLoadAnalysis
  }) : null, /*#__PURE__*/React.createElement(TopAppsAndWebsites, {
    teamTopAppsAndWebsite: overViewData.overviewData.teamTopAppsAndWebsite,
    organisationSettings: organisationSettings
  }), /*#__PURE__*/React.createElement(LateClockInDetails, {
    lateClockInDetails: overViewData === null || overViewData === void 0 ? void 0 : (_overViewData$overvie = overViewData.overviewData) === null || _overViewData$overvie === void 0 ? void 0 : _overViewData$overvie.lateClockInDetails,
    organisationSettings: organisationSettings,
    history: props === null || props === void 0 ? void 0 : props.history,
    startDate: startDate,
    endDate: endDate,
    Link: Link,
    linkProps: linkProps
  }), /*#__PURE__*/React.createElement(AbsentDetails, {
    absentDetails: overViewData === null || overViewData === void 0 ? void 0 : (_overViewData$overvie2 = overViewData.overviewData) === null || _overViewData$overvie2 === void 0 ? void 0 : _overViewData$overvie2.absentDetails,
    organisationSettings: organisationSettings,
    history: props === null || props === void 0 ? void 0 : props.history,
    startDate: startDate,
    endDate: endDate,
    dateFilter: dateFilter,
    Link: Link,
    linkProps: linkProps
  }), dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? /*#__PURE__*/React.createElement(RecentApps, {
    Link: Link,
    linkProps: linkProps,
    teamId: teamId,
    organisationId: organisationId,
    startDate: Number(moment(startDate).format("x")),
    endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userRole: filterRole,
    location: props.location.key
  }) : null, organisationBilling.planName != "free" ? /*#__PURE__*/React.createElement(RiskDetection, {
    riskFactor: overviewUserWorkDetailsData === null || overviewUserWorkDetailsData === void 0 ? void 0 : (_overviewUserWorkDeta = overviewUserWorkDetailsData.overviewUserWorkDetails) === null || _overviewUserWorkDeta === void 0 ? void 0 : _overviewUserWorkDeta.riskFactor,
    overviewUserWorkDetailsError: overviewUserWorkDetailsError,
    overviewUserWorkDetailsLoading: overviewUserWorkDetailsLoading,
    Link: Link,
    linkProps: linkProps,
    setOverviewUserDataFetch: setOverviewUserDataFetch,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : null, /*#__PURE__*/React.createElement(WorkSummaryScreenshot, {
    screenshots: overviewUserWorkDetailsData === null || overviewUserWorkDetailsData === void 0 ? void 0 : (_overviewUserWorkDeta2 = overviewUserWorkDetailsData.overviewUserWorkDetails) === null || _overviewUserWorkDeta2 === void 0 ? void 0 : _overviewUserWorkDeta2.screenshots,
    overviewUserWorkDetailsError: overviewUserWorkDetailsError,
    overviewUserWorkDetailsLoading: overviewUserWorkDetailsLoading,
    dateFilter: dateFilter,
    organisationSettings: organisationSettings,
    teamId: teamId,
    role: filterRole,
    Link: Link,
    linkProps: linkProps,
    setOverviewUserDataFetch: setOverviewUserDataFetch
  }), /*#__PURE__*/React.createElement(UserTableSummary
  // userWorkDetails={overviewUserWorkDetailsData?.overviewUserWorkDetails?.userWorkDetails}
  // overviewUserWorkDetailsError={overviewUserWorkDetailsError}
  // overviewUserWorkDetailsLoading={overviewUserWorkDetailsLoading}
  , {
    Link: Link,
    linkProps: linkProps
    //setOverviewUserDataFetch={setOverviewUserDataFetch}
    ,
    teamId: teamId,
    organisationId: organisationId,
    startDate: Number(moment(startDate).format("x")),
    endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userRole: filterRole,
    location: props.location.key
  }), filterRole == "Admin" || leaveSettingsCheckForUser && filterRole != "Admin" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UpcoimgHolidays, {
    upcomingHolidayData: upcomingLeaveDetailsData === null || upcomingLeaveDetailsData === void 0 ? void 0 : (_upcomingLeaveDetails = upcomingLeaveDetailsData.overviewUpcomingDetails) === null || _upcomingLeaveDetails === void 0 ? void 0 : _upcomingLeaveDetails.upcomingHoliday,
    upcomingLeaveDetailsLoading: upcomingLeaveDetailsLoading,
    upcomingLeaveDetailsError: upcomingLeaveDetailsError
  }), /*#__PURE__*/React.createElement(UpcomingLeaves, {
    upcoimgLeaveData: upcomingLeaveDetailsData === null || upcomingLeaveDetailsData === void 0 ? void 0 : (_upcomingLeaveDetails2 = upcomingLeaveDetailsData.overviewUpcomingDetails) === null || _upcomingLeaveDetails2 === void 0 ? void 0 : _upcomingLeaveDetails2.upcoimgLeave,
    upcomingLeaveDetailsLoading: upcomingLeaveDetailsLoading,
    upcomingLeaveDetailsError: upcomingLeaveDetailsError,
    history: props === null || props === void 0 ? void 0 : props.history,
    Link: Link,
    linkProps: linkProps
  })) : null));
};
export var WarningCardBilling = function WarningCardBilling(props) {
  var planName = props.planName,
    isTrial = props.isTrial;
  return /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-card-pro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-text1"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-2nd-text-new-font-weight"
  }, "Dear Team,"), /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text"
  }, "Due to unavoidable reasons, We have migrated our domain name from", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://get.workfolio.com/workfolio-io/",
    className: "warning-card-dashboard-link",
    target: "_blank"
  }, "workfolio.io"), " ", "to", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.getworkfolio.com/",
    className: "warning-card-dashboard-link",
    target: "_blank"
  }, "getworkfolio.com"), ". We understand your pain behind reinstalling all your team members' desktop to the latest version. To compensate your time lose, we are extending your subscription for 10 days. It means, you will get additional 10 days of validity in your current subscription."), /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-text-new warning-billing-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text"
  }, "Thanks"), /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-text-new warning-billing-dashboard-card-title-2nd-text-new-font"
  }, "Team Workfolio"))))));
};
export var NewProductCard = function NewProductCard(props) {
  var planName = props.planName,
    isTrial = props.isTrial;
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    showBanner = _React$useState4[0],
    setShowBanner = _React$useState4[1];
  React.useEffect(function () {
    var isBannerClosed = localStorage.getItem("newToolbannerClosed") || planName != "free";
    if (isBannerClosed) {
      setShowBanner(false);
    }
  }, []);
  return showBanner ? /*#__PURE__*/React.createElement("div", {
    className: "new-product-summary-dashboard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-product-summary-container"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: "new-product-summary-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-product-summary-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-product-summary-text-1"
  }, "Are you a remote team or fast-moving startup? Skip the daily standup hassle \u2014 try Workfolio Bot for Slack. It runs standups and check-ins automatically, keeps your team in sync, and it's completely free to try.", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://bot.getworkfolio.com/",
    target: "_blank"
  }, "Try it here"), "."), " ", planName == "pro" && isTrial != true ? /*#__PURE__*/React.createElement(MdClose, {
    size: 20,
    style: {
      color: "#fff",
      transition: "opacity 0.2s",
      cursor: "pointer",
      fontSize: "15px"
    },
    onClick: function onClick() {
      localStorage.setItem("newToolbannerClosed", "true");
      setShowBanner(false);
    }
  }) :
  // </Button>
  null))))) : null;
};
export var WarningCardMaintenance = function WarningCardMaintenance(props) {
  var planName = props.planName,
    isTrial = props.isTrial;
  return (
    /*#__PURE__*/
    // <div className="waring-dashboard-summary">
    //   {planName == "pro" && isTrial != true ? (
    //     <div className="waring-dashboard-card-pro">
    //       <div className="warning-dashboard-card-title">
    //         <div className="warning-dashboard-card-title-text1">
    //           <div>
    //             <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font">
    //               Dear Valuable paid users, you are the reason for our growth. For the past few days, we have been
    //               facing an issue for a few hours.{" "}
    //               <span className="warning-dashboard-card-title-3rd-text warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-2nd-text-new-font-weight">
    //                 We understand your concern & we want to compensate you. So, we are extending your subscription
    //                 validity for 3 extra days.
    //               </span>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   ) : (
    //     <div className="waring-dashboard-card-pro">
    //       <div className="warning-dashboard-card-title">
    //         <div className="warning-dashboard-card-title-text1">
    //           <span className="">Dear Valued User,</span>
    //           <div className="warning-dashboard-card-title-text1-span">
    //             We are pleased to inform you that the scheduled maintenance on our product has been successfully
    //             completed. Our system is now fully operational, and all services have been restored.
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </div>
    // <div className="waring-dashboard-summary">
    //   <div className="waring-dashboard-card-pro">
    //     <div className="warning-dashboard-card-title">
    //       <div className="warning-dashboard-card-title-text1">
    //         <div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-2nd-text-new-font-weight">
    //             Dear Team, Greetings.
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text">
    //             We have migrated our domain name from{" "}
    //             <a
    //               href="https://get.workfolio.com/workfolio-io/"
    //               className="warning-card-dashboard-link"
    //               target="_blank"
    //             >
    //               workfolio.io
    //             </a>{" "}
    //             to{" "}
    //             <a href="https://www.getworkfolio.com/" className="warning-card-dashboard-link" target="_blank">
    //               getworkfolio.com
    //             </a>
    //             .
    //           </div>
    //           <div className="warning-dashboard-card-title-3rd-text warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-2nd-text-new-font-weight">
    //             Why this change?
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font">
    //             Currently, we have lost control over our domain name (
    //             <a
    //               href="https://get.workfolio.com/workfolio-io/"
    //               className="warning-card-dashboard-link"
    //               target="_blank"
    //             >
    //               workfolio.io
    //             </a>
    //             ) due to third-party reasons. We are communicating with our domain name provider{" "}
    //             <a href="https://www.godaddy.com/en-in" className="warning-card-dashboard-link" target="_blank">
    //               GoDaddy.com
    //             </a>{" "}
    //             to resolve this.
    //           </div>
    //           <div className="warning-dashboard-card-title-3rd-text warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-2nd-text-new-font-weight">
    //             What needs to be done?
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font">
    //             Team members will need to download and reinstall the desktop app. Here is the link to download the
    //             latest app{" "}
    //             <a
    //               href="https://www.getworkfolio.com/downloads"
    //               className="warning-card-dashboard-link"
    //               target="_blank"
    //             >
    //               www.getworkfolio.com/downloads
    //             </a>
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text">
    //             Likewise, our email ID is updated to{" "}
    //             <span className="warning-card-dashboard-link-span">team@getworkfolio.com </span>. Old email is not
    //             supported anymore.
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text">
    //             If you or your team members have lost any work hours, due to this incident. Pls fill out this form,{" "}
    //             <a
    //               href="https://docs.google.com/forms/d/e/1FAIpQLSd6tqyLGHPg_i4WugiADXBpx7HmlqTWRd3FJh8LhitqJyicVg/viewform?pli=1"
    //               className="warning-card-dashboard-link"
    //               target="_blank"
    //             >
    //               https://forms.gle/gEziXTdTmaFskzhy9
    //             </a>
    //             . We will update the hours on our side. Sorry for the inconvenience caused.
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    // <div className="waring-dashboard-summary">
    //   <div className="waring-dashboard-card-pro-maintain">
    //     <div className="warning-dashboard-card-title">
    //       <div className="warning-dashboard-card-title-text1">
    //         <div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-2nd-text-new-font-weight">
    //             Scheduled Maintenance Notification
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text">
    //             We will be performing scheduled maintenance on November 28, from 03:30 AM UTC to 04:30 AM UTC. During
    //             this time, the Workfolio desktop app and website will not be accessible. We apologize for any
    //             inconvenience and appreciate your understanding.{" "}
    //           </div>
    //           <div className="warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font warning-dashboard-card-title-3rd-text">
    //             If you need any more info, please reach out through email (
    //             <a
    //               href="https://get.workfolio.com/workfolio-io/"
    //               className="warning-card-dashboard-link"
    //               target="_blank"
    //             >
    //               team@getworkfolio.com
    //             </a>
    //             ) or{" "}
    //             <a href="https://tawk.to/workfolio" className="warning-card-dashboard-link" target="_blank">
    //               support chat
    //             </a>
    //             .
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    React.createElement("div", {
      className: "waring-dashboard-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "waring-dashboard-card-pro"
    }, /*#__PURE__*/React.createElement("div", {
      className: "warning-dashboard-card-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "warning-dashboard-card-title-text1"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font"
    }, "Workfolio desktop app is down due to the server overload. We are investigating the issue. Really sorry for the inconvenience. Please check out the live update here", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.statuspage.io/",
      className: "warning-card-dashboard-link",
      target: "_blank"
    }, "https://workfolio.statuspage.io/")))))))
  );
};
export var WarningCard = function WarningCard(props) {
  var organisationId = props.organisationId;
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    gstModalShow = _React$useState6[0],
    setGstModalShow = _React$useState6[1];
  var handleTaxClose = function handleTaxClose() {
    return setGstModalShow(null);
  };
  var handleTaxDeleteShow = function handleTaxDeleteShow() {
    return setGstModalShow(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-text1"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font"
  }, "We are informing you about an important update regarding your payment on our platform. We have recently enabled the Goods and Services Tax (GST) on our platform, as required by government regulations. The GST rate for our services is 18%, and you will now see this component added to your payment amount."), /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-div warning-dashboard-card-title-2nd-text-new-font"
  }, "Please note that the GST tax is mandatory and will be reflected in your invoice separately. Please add your GST details, we will add them to your upcoming invoices. So that means you can claim 18% of your payment.", " ", /*#__PURE__*/React.createElement("span", {
    className: "warning-dashboard-card-title-2nd-span",
    onClick: function onClick() {
      return handleTaxDeleteShow();
    }
  }, "Click to add your GSTIN number.")), /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-div warning-dashboard-card-title-3rd-div warning-dashboard-card-title-2nd-text-new-font"
  }, "if you or your business have already provided the GST details, please skip the above message."))))), /*#__PURE__*/React.createElement(TaxModal, {
    gstModalShow: gstModalShow,
    handleTaxClose: handleTaxClose,
    organisationId: organisationId
  }));
};
export var WarningCardOrgTimezone = function WarningCardOrgTimezone(props) {
  var currentSystemDate = props.currentSystemDate,
    orgTimezoneDate = props.orgTimezoneDate,
    currentSystemTimezone = props.currentSystemTimezone,
    organisationTimezone = props.organisationTimezone;
  var currentSystemDateTemp = moment().tz(currentSystemTimezone).format("YYYY-MM-DD HH:mm:ss");
  var orgTimezoneDateTemp = moment().tz(organisationTimezone).format("YYYY-MM-DD HH:mm:ss");
  var currentSystemUnix = moment(currentSystemDateTemp, "YYYY-MM-DD HH:mm:ss").tz(currentSystemTimezone).valueOf();
  var orgTimezoneUnix = moment(orgTimezoneDateTemp, "YYYY-MM-DD HH:mm:ss").tz(organisationTimezone).valueOf();
  return /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-timezone-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-timezone-card-pro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-timezone-card-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-timezone-card-title-text1"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-timezone-card-title-2nd-text-new warning-dashboard-timezone-card-title-2nd-text-new-font warning-dashboard-timezone-card-title-3rd-text"
  }, /*#__PURE__*/React.createElement(AiFillInfoCircle, {
    className: "warning-dashboard-timezone-card-icon"
  }), "Please select ", /*#__PURE__*/React.createElement("span", {
    className: "warning-dashboard-timezone-card-text-sub"
  }, orgTimezoneDate), " on the calender to view today's report, as your computer's date (", /*#__PURE__*/React.createElement("span", {
    className: "warning-dashboard-timezone-card-text-sub"
  }, currentSystemDate), ") is", " ", currentSystemUnix < orgTimezoneUnix ? "behind" : "ahead of", " your organization's current date.", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/how-to-change-the-date-in-workfolio",
    target: "_blank",
    className: "warning-dashboard-timezone-card-text-help"
  }, "For Help.")))))));
};
var taxSchema = Yup.object().shape({
  gstNumber: Yup.string().trim().required("Required")
});
var TaxModal = function TaxModal(props) {
  var gstModalShow = props.gstModalShow,
    handleTaxClose = props.handleTaxClose,
    organisationId = props.organisationId;
  if (gstModalShow === null) {
    return null;
  }
  var _useMutation = useMutation(UPDATE_GST_NUMBER_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateGstNumber = _useMutation2[0],
    updateGstNumberLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var gstNumber, variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            gstNumber = values.gstNumber;
            variables = {
              gstNumber: gstNumber,
              organisationId: organisationId
            };
            _context.prev = 2;
            _context.next = 5;
            return updateGstNumber({
              variables: variables,
              awaitRefetchQueries: true
            });
          case 5:
            response = _context.sent;
            if (!(!response || !response.data || response.data.updateGstNumber == null)) {
              _context.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            handleTaxClose();
            toast.success("Thanks for adding your GSTIN number. We will add it in your upcoming invoices. Thank you.");
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            toast.error("Error Occured, Pls try again later!!!");
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [updateGstNumber, updateGstNumberLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleTaxClose,
    centered: true,
    className: "dashboard-tax-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "dashboard-tax-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "dashboard-tax-modal-title"
  }, "Enter your GST Details")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      gstNumber: ""
    },
    validationSchema: taxSchema,
    onSubmit: handleSubmit
  }, function (_ref2) {
    var setFieldValue = _ref2.setFieldValue,
      errors = _ref2.errors,
      touched = _ref2.touched,
      values = _ref2.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "dashboard-tax-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-tax-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "gstNumber"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "dashboard-tax-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "dashboard-tax-modal-label-name"
      }, "GSTIN Number"), /*#__PURE__*/React.createElement("span", {
        className: "dashboard-tax-modal-label-name-required"
      }, " *"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "e.g. 33AABCU9603R1ZU",
        className: "dashboard-tax-edit-project-label-input"
      }, field)));
    }))))), /*#__PURE__*/React.createElement(Row, {
      className: "dashboard-tax-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "dashboard-tax-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-tax-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "dashboard-tax-modal-save-button",
      type: "submit",
      disabled: updateGstNumberLoading
    }, updateGstNumberLoading ? "Loading..." : "Save"))))));
  }), " "));
};
var WorkSummary = function WorkSummary(props) {
  var overviewSummary = props.overviewSummary,
    pageComponent = props.pageComponent,
    organisationUserCount = props.organisationUserCount,
    dateFilter = props.dateFilter,
    startDate = props.startDate;
  //const { overviewSummary, pageComponent, organisationUserCount,subscribeToCurrentlyWorking } = props;

  // React.useEffect(() => {
  //   const unsubscribe = subscribeToCurrentlyWorking();
  //   return unsubscribe;
  // }, []);
  //<div className={`dashboard-summary ${Number(organisationUserCount) <= 1 ? "dashboard-card-opacity" : null}`}>

  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Total Team Members"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, overviewSummary.totalUsers)), dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "currently-working",
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-whole"
    }, overviewSummary.workingMembersUser.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, overviewSummary.workingMembersUser.slice(0, 15).map(function (data, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-header"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: data.profileUrl ? data.profileUrl : Profile,
        className: "count-tooltip-user-content-img",
        width: "15",
        height: "15"
      }), /*#__PURE__*/React.createElement("p", {
        className: "count-tooltip-user-content"
      }, data.displayName));
    }), overviewSummary.currentlyWorking > 15 ? /*#__PURE__*/React.createElement("p", {
      className: "count-tooltip-user-content"
    }, "+", overviewSummary.currentlyWorking - 15, " others") : null) : /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-header"
    }, " No members")))
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card ".concat(dateFilter !== "Today" && Number(moment(startDate).format("x")) < Number(moment().format("x")) ? "dashboard-card-opacity" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Currently Working"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? overviewSummary.currentlyWorking : "-"))) : /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card ".concat(dateFilter !== "Today" && Number(moment(startDate).format("x")) < Number(moment().format("x")) ? "dashboard-card-opacity" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Currently Working"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? overviewSummary.currentlyWorking : "-")), dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "currently-break",
    placement: "bottom-start",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip"
    }, /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-whole"
    }, overviewSummary.breakMembersUser.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, overviewSummary.breakMembersUser.slice(0, 15).map(function (data, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-header"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: data.profileUrl ? data.profileUrl : Profile,
        className: "count-tooltip-user-content-img",
        width: "15",
        height: "15"
      }), /*#__PURE__*/React.createElement("p", {
        className: "count-tooltip-user-content"
      }, data.displayName));
    }), overviewSummary.currentlyBreak > 15 ? /*#__PURE__*/React.createElement("p", {
      className: "count-tooltip-user-content"
    }, "+", overviewSummary.currentlyBreak - 15, " others") : null) : /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-header"
    }, " No members")))
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card ".concat(dateFilter !== "Today" && Number(moment(startDate).format("x")) < Number(moment().format("x")) ? "dashboard-card-opacity" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Currently On Break"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? overviewSummary.currentlyBreak : "-"))) : /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card ".concat(dateFilter !== "Today" && Number(moment(startDate).format("x")) < Number(moment().format("x")) ? "dashboard-card-opacity" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Currently On Break"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? overviewSummary.currentlyBreak : "-")), dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "currently-stoped",
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-stop"
    }, /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-whole"
    }, overviewSummary.stopMembersUser.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, overviewSummary.stopMembersUser.slice(0, 15).map(function (data, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-header"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: data.profileUrl ? data.profileUrl : Profile,
        className: "count-tooltip-user-content-img",
        width: "15",
        height: "15"
      }), /*#__PURE__*/React.createElement("p", {
        className: "count-tooltip-user-content"
      }, data.displayName));
    }), overviewSummary.currentlyStop > 15 ? /*#__PURE__*/React.createElement("p", {
      className: "count-tooltip-user-content"
    }, "+", overviewSummary.currentlyStop - 15, " others") : null) : /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-header"
    }, " No members")))
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card ".concat(dateFilter !== "Today" && Number(moment(startDate).format("x")) < Number(moment().format("x")) ? "dashboard-card-opacity" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Currently Stopped Work"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? overviewSummary.currentlyStop : "-"))) : /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card ".concat(dateFilter !== "Today" && Number(moment(startDate).format("x")) < Number(moment().format("x")) ? "dashboard-card-opacity" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "Currently Stopped Work"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, dateFilter === "Today" || Number(moment(startDate).format("x")) >= Number(moment().format("x")) ? overviewSummary.currentlyStop : "-")), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card summary-hover-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card-title text-dark"
  }, "App Not Installed"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, overviewSummary.desktopAppNotInstalledCount)));
};
var getColumns = function getColumns() {
  return [{
    Header: "Member",
    accessor: "userName"
  }, {
    Header: "Hours Worked",
    accessor: "hoursWorked"
  }, {
    Header: "ClockIn",
    accessor: "checkInTime"
  }];
};
var WorkSummaryScreenshot = function WorkSummaryScreenshot(props) {
  var screenshots = props.screenshots,
    dateFilter = props.dateFilter,
    organisationSettings = props.organisationSettings,
    teamId = props.teamId,
    role = props.role,
    Link = props.Link,
    linkProps = props.linkProps,
    overviewUserWorkDetailsLoading = props.overviewUserWorkDetailsLoading,
    overviewUserWorkDetailsError = props.overviewUserWorkDetailsError,
    setOverviewUserDataFetch = props.setOverviewUserDataFetch;
  var screenshotData = role === "Admin" || teamId == "all" ? organisationSettings.screenCapture : true;
  var screenshotSettings = organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo || organisationSettings.allowMemberToAccessScreenCapture ? true : false;
  if (overviewUserWorkDetailsLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table"
    }, /*#__PURE__*/React.createElement("div", {
      className: "recent-screenshot-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "head-screenshot-card"
    }, /*#__PURE__*/React.createElement("span", {
      className: "head-website-list"
    }, "Recent Screenshots")), /*#__PURE__*/React.createElement(Loader, null)));
  }
  if (overviewUserWorkDetailsError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!screenshots) {
    return null;
  }
  setOverviewUserDataFetch(false);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recent-screenshot-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-screenshot-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "head-website-list"
  }, "Recent Screenshots"), " ", /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/screenshots"), {
    key: "screenshots"
  }), /*#__PURE__*/React.createElement("div", {
    className: "head-screenshot-card-link"
  }, screenshotData === "true" ? "See more" : null))), screenshotData === true ? screenshots.length !== 0 && screenshotSettings ? /*#__PURE__*/React.createElement("div", {
    className: "recent-screenshot-content screenshots-list"
  }, screenshots.map(function (screenshotData, key) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      key: "thumb",
      alt: "User Screenshot",
      className: "screenshots-list-img",
      src: screenshotData.thumbnailUrl
      // onClick={() => window.open(screenshotData.imageUrl, "_blank")}
    }), /*#__PURE__*/React.createElement("p", {
      className: "screenshot-overview-display-name displayName"
    }, screenshotData.displayName));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No screenshot found") : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "Screenshot tracking is disabled")));
};
var RecentApps = function RecentApps(props) {
  var _overViewDataRecentAp5, _overViewDataRecentAp8, _overViewDataRecentAp9, _overViewDataRecentAp10, _overViewDataRecentAp11;
  var Link = props.Link,
    linkProps = props.linkProps,
    teamId = props.teamId,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    userRole = props.userRole,
    location = props.location;
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoaded = _React$useState8[0],
    setIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMore = _React$useState10[0],
    setIsLoadingMore = _React$useState10[1];
  var _useQuery2 = useQuery(OVERVIEW_CURRENTLY_USING_DATA_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: startDate,
        endDate: endDate,
        timeZone: timeZone,
        userRole: userRole,
        limit: CURRENTLY_LIMIT,
        offset: 0
      },
      skip: !teamId || !organisationId
    }),
    overViewDataRecentApps = _useQuery2.data,
    overviewUserWorkDetailsError = _useQuery2.error,
    overviewUserWorkDetailsLoading = _useQuery2.loading,
    recentAppsDataFetchMore = _useQuery2.fetchMore,
    refetch = _useQuery2.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [location]);
  React.useEffect(function () {
    var _overViewDataRecentAp, _overViewDataRecentAp2, _overViewDataRecentAp3, _overViewDataRecentAp4;
    if ((overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp === void 0 ? void 0 : (_overViewDataRecentAp2 = _overViewDataRecentAp.recentApps) === null || _overViewDataRecentAp2 === void 0 ? void 0 : _overViewDataRecentAp2.length) !== 0 && (overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp3 = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp3 === void 0 ? void 0 : (_overViewDataRecentAp4 = _overViewDataRecentAp3.recentApps) === null || _overViewDataRecentAp4 === void 0 ? void 0 : _overViewDataRecentAp4.length) < CURRENTLY_LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp5 = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp5 === void 0 ? void 0 : _overViewDataRecentAp5.recentApps]);
  if (overviewUserWorkDetailsLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table"
    }, /*#__PURE__*/React.createElement("div", {
      className: "recent-screenshot-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "head-screenshot-card"
    }, /*#__PURE__*/React.createElement("span", {
      className: "head-website-list"
    }, "Currently using Apps and Websites"), " "), /*#__PURE__*/React.createElement(Loader, null)));
  }
  if (overviewUserWorkDetailsError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!overViewDataRecentApps) {
    return null;
  }

  //setOverviewUserDataFetch(false);

  var handleLoadMore = function handleLoadMore() {
    var _overViewDataRecentAp6, _overViewDataRecentAp7;
    if (overviewUserWorkDetailsLoading) return;
    setIsLoadingMore(true);
    recentAppsDataFetchMore({
      variables: {
        offset: overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp6 = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp6 === void 0 ? void 0 : (_overViewDataRecentAp7 = _overViewDataRecentAp6.recentApps) === null || _overViewDataRecentAp7 === void 0 ? void 0 : _overViewDataRecentAp7.length
      },
      updateQuery: function updateQuery(prev, _ref4) {
        var _fetchMoreResult$over, _fetchMoreResult$over2, _fetchMoreResult$over3, _fetchMoreResult$over4, _prev$overviewCurrent, _fetchMoreResult$over5;
        var fetchMoreResult = _ref4.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$over = fetchMoreResult.overviewCurrentlyUsingApp) === null || _fetchMoreResult$over === void 0 ? void 0 : (_fetchMoreResult$over2 = _fetchMoreResult$over.recentApps) === null || _fetchMoreResult$over2 === void 0 ? void 0 : _fetchMoreResult$over2.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$over3 = fetchMoreResult.overviewCurrentlyUsingApp) === null || _fetchMoreResult$over3 === void 0 ? void 0 : (_fetchMoreResult$over4 = _fetchMoreResult$over3.recentApps) === null || _fetchMoreResult$over4 === void 0 ? void 0 : _fetchMoreResult$over4.length) < CURRENTLY_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          overviewCurrentlyUsingApp: _objectSpread(_objectSpread({}, prev.overviewCurrentlyUsingApp), {}, {
            recentApps: [].concat(_toConsumableArray((_prev$overviewCurrent = prev.overviewCurrentlyUsingApp) === null || _prev$overviewCurrent === void 0 ? void 0 : _prev$overviewCurrent.recentApps), _toConsumableArray((_fetchMoreResult$over5 = fetchMoreResult.overviewCurrentlyUsingApp) === null || _fetchMoreResult$over5 === void 0 ? void 0 : _fetchMoreResult$over5.recentApps))
          })
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recent-screenshot-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-screenshot-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "head-website-list"
  }, "Currently using Apps and Websites"), " "), (overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp8 = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp8 === void 0 ? void 0 : _overViewDataRecentAp8.recentApps.length) !== 0 ? /*#__PURE__*/React.createElement("div", {
    className: "recent-apps-card-content"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp9 = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp9 === void 0 ? void 0 : _overViewDataRecentAp9.recentApps.map(function (recentAppsData, key) {
    return /*#__PURE__*/React.createElement("div", {
      className: "recent-apps-card"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      src: recentAppsData.icon,
      alt: "workfolio",
      className: "recent-apps-card-website-icon"
    })), /*#__PURE__*/React.createElement("div", {
      className: "recent-apps-card-display-name"
    }, " ", /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(recentAppsData === null || recentAppsData === void 0 ? void 0 : recentAppsData.uniqueUrl)), {
      key: "recent-".concat(recentAppsData === null || recentAppsData === void 0 ? void 0 : recentAppsData.uniqueUrl)
    }), /*#__PURE__*/React.createElement("div", {
      className: "recent-apps-card-display-name-value"
    }, recentAppsData.displayName)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-team-name",
        className: "app-count-tooltip-start"
      }, recentAppsData.windowTitle ? recentAppsData.windowTitle : recentAppsData.title)
    }, /*#__PURE__*/React.createElement("div", {
      className: "recent-apps-card-display-app-name-value"
    }, recentAppsData.windowTitle ? /*#__PURE__*/React.createElement(React.Fragment, null, recentAppsData.windowTitle === "" ? "Unknown file" : recentAppsData.windowTitle) : /*#__PURE__*/React.createElement(React.Fragment, null, recentAppsData.title === "" ? "Unknown file" : recentAppsData.title)))));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No recent app found"), !overviewUserWorkDetailsLoading && overViewDataRecentApps !== null && overViewDataRecentApps !== void 0 && (_overViewDataRecentAp10 = overViewDataRecentApps.overviewCurrentlyUsingApp) !== null && _overViewDataRecentAp10 !== void 0 && _overViewDataRecentAp10.recentApps && (overViewDataRecentApps === null || overViewDataRecentApps === void 0 ? void 0 : (_overViewDataRecentAp11 = overViewDataRecentApps.overviewCurrentlyUsingApp) === null || _overViewDataRecentAp11 === void 0 ? void 0 : _overViewDataRecentAp11.recentApps.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: ""
  }, !isAllLoaded ? null : /*#__PURE__*/React.createElement("div", {
    className: "recent-apps-card-load-more-p-div"
  }, "You have seen all the users")) : null));
};
var RiskDetection = function RiskDetection(props) {
  var _riskFactor$riskyUser, _riskFactor$riskyUser2, _riskFactor$riskyUser3, _riskFactor$riskyUser4;
  var riskFactor = props.riskFactor,
    Link = props.Link,
    linkProps = props.linkProps,
    overviewUserWorkDetailsError = props.overviewUserWorkDetailsError,
    overviewUserWorkDetailsLoading = props.overviewUserWorkDetailsLoading,
    setOverviewUserDataFetch = props.setOverviewUserDataFetch,
    history = props.history;
  if (overviewUserWorkDetailsLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table"
    }, /*#__PURE__*/React.createElement("div", {
      className: "recent-screenshot-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "head-screenshot-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "head-website-list-heading"
    }, "Risky Users")), /*#__PURE__*/React.createElement(Loader, null)));
  }
  if (overviewUserWorkDetailsError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!riskFactor) {
    return null;
  }
  setOverviewUserDataFetch(false);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recent-screenshot-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-screenshot-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-website-list-heading"
  }, "Risky Users"), /*#__PURE__*/React.createElement("div", {
    className: "head-website-list-risk"
  }, /*#__PURE__*/React.createElement("span", {
    className: "head-website-list-user-count-header"
  }, " ", riskFactor === null || riskFactor === void 0 ? void 0 : riskFactor.userTotalCount, " ", /*#__PURE__*/React.createElement("span", {
    className: "head-website-list-user-small-header"
  }, "users")))), /*#__PURE__*/React.createElement("div", {
    className: "overview-risk-listing"
  }, (riskFactor === null || riskFactor === void 0 ? void 0 : (_riskFactor$riskyUser = riskFactor.riskyUserData) === null || _riskFactor$riskyUser === void 0 ? void 0 : _riskFactor$riskyUser.length) !== 0 ? riskFactor === null || riskFactor === void 0 ? void 0 : (_riskFactor$riskyUser2 = riskFactor.riskyUserData) === null || _riskFactor$riskyUser2 === void 0 ? void 0 : _riskFactor$riskyUser2.map(function (riskFactorData, key) {
    var _riskFactorData$ruleD, _riskFactorData$displ, _riskFactorData$ruleD2, _riskFactorData$ruleD3, _riskFactorData$ruleD4, _riskFactorData$ruleD5;
    var ruleName = riskFactorData === null || riskFactorData === void 0 ? void 0 : (_riskFactorData$ruleD = riskFactorData.ruleDetails[0]) === null || _riskFactorData$ruleD === void 0 ? void 0 : _riskFactorData$ruleD.ruleName;
    return /*#__PURE__*/React.createElement("div", {
      className: "overview-risk-listing-content"
    }, riskFactorData !== null && riskFactorData !== void 0 && riskFactorData.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "risk-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: riskFactorData === null || riskFactorData === void 0 ? void 0 : riskFactorData.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "risk-root-content-data-details-avatar-circle"
    }, riskFactorData === null || riskFactorData === void 0 ? void 0 : (_riskFactorData$displ = riskFactorData.displayName) === null || _riskFactorData$displ === void 0 ? void 0 : _riskFactorData$displ.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "overview-risk-listing-content-text"
    }, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(riskFactorData === null || riskFactorData === void 0 ? void 0 : riskFactorData.uniqueUrl)), {
      key: "risk-".concat(riskFactorData === null || riskFactorData === void 0 ? void 0 : riskFactorData.userId)
    }), /*#__PURE__*/React.createElement("p", {
      className: "risk-root-content-data-details-name-data-team-name"
    }, riskFactorData === null || riskFactorData === void 0 ? void 0 : riskFactorData.displayName)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-risk-violation",
        className: "risk-count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-whole"
      }, riskFactorData === null || riskFactorData === void 0 ? void 0 : (_riskFactorData$ruleD2 = riskFactorData.ruleDetails) === null || _riskFactorData$ruleD2 === void 0 ? void 0 : _riskFactorData$ruleD2.map(function (ruleList, key) {
        return /*#__PURE__*/React.createElement("p", {
          className: "risk-root-content-data-details-name-data-team-name-rule-text-accordance"
        }, /*#__PURE__*/React.createElement("span", {
          className: "risk-root-rule-key"
        }, key + 1, "."), " ", /*#__PURE__*/React.createElement("span", null, ruleList === null || ruleList === void 0 ? void 0 : ruleList.title), " ");
      })))
    }, /*#__PURE__*/React.createElement("div", {
      className: "overview-risk-listing-content-violation-text-div"
    }, /*#__PURE__*/React.createElement("p", {
      className: "overview-risk-listing-content-violation-text-span"
    }, ruleName, (riskFactorData === null || riskFactorData === void 0 ? void 0 : (_riskFactorData$ruleD3 = riskFactorData.ruleDetails) === null || _riskFactorData$ruleD3 === void 0 ? void 0 : _riskFactorData$ruleD3.length) === 1 ? "" : ", "), " ", /*#__PURE__*/React.createElement("span", {
      className: "overview-risk-listing-content-violation-number-span"
    }, (riskFactorData === null || riskFactorData === void 0 ? void 0 : (_riskFactorData$ruleD4 = riskFactorData.ruleDetails) === null || _riskFactorData$ruleD4 === void 0 ? void 0 : _riskFactorData$ruleD4.length) === 1 ? "" : "+".concat((riskFactorData === null || riskFactorData === void 0 ? void 0 : (_riskFactorData$ruleD5 = riskFactorData.ruleDetails) === null || _riskFactorData$ruleD5 === void 0 ? void 0 : _riskFactorData$ruleD5.length) - 1, " More"))))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text overview-risk-factor-no-data-text overview-no-data-grid"
  }, "No data found !!!"), (riskFactor === null || riskFactor === void 0 ? void 0 : (_riskFactor$riskyUser3 = riskFactor.riskyUserData) === null || _riskFactor$riskyUser3 === void 0 ? void 0 : _riskFactor$riskyUser3.length) > 0 && (riskFactor === null || riskFactor === void 0 ? void 0 : (_riskFactor$riskyUser4 = riskFactor.riskyUserData) === null || _riskFactor$riskyUser4 === void 0 ? void 0 : _riskFactor$riskyUser4.length) >= 15 ? /*#__PURE__*/React.createElement("div", {
    className: "overview-late-clockin-details-table-load-more-btn-div"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    onClick: function onClick() {
      history.push("/risk-user-history");
    },
    className: "overview-late-clockin-details-table-load-more-btn-risk"
  }, "See all the risk employees")) : null)));
};
var UserTableSummary = function UserTableSummary(props) {
  var _data$overviewWorkedH5, _data$overviewWorkedH6, _data$overviewWorkedH7, _data$overviewWorkedH10;
  var columns = React.useMemo(function () {
    return getColumns();
  }, []);
  var Link = props.Link,
    linkProps = props.linkProps,
    teamId = props.teamId,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    userRole = props.userRole,
    location = props.location;
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isAllLoaded = _React$useState12[0],
    setIsAllLoaded = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isLoadingMore = _React$useState14[0],
    setIsLoadingMore = _React$useState14[1];
  var _useQuery3 = useQuery(OVERVIEW_WORKED_HOUR_USING_DATA_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        startDate: startDate,
        endDate: endDate,
        timeZone: timeZone,
        userRole: userRole,
        limit: WORK_HOUR_LIMIT,
        offset: 0
      },
      skip: !teamId || !organisationId
    }),
    data = _useQuery3.data,
    overviewUserWorkDetailsError = _useQuery3.error,
    overviewUserWorkDetailsLoading = _useQuery3.loading,
    overviewWorkDataFetchMore = _useQuery3.fetchMore,
    refetch = _useQuery3.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [location]);
  React.useEffect(function () {
    var _data$overviewWorkedH, _data$overviewWorkedH2, _data$overviewWorkedH3, _data$overviewWorkedH4;
    if ((data === null || data === void 0 ? void 0 : (_data$overviewWorkedH = data.overviewWorkedHourDetails) === null || _data$overviewWorkedH === void 0 ? void 0 : (_data$overviewWorkedH2 = _data$overviewWorkedH.userWorkDetails) === null || _data$overviewWorkedH2 === void 0 ? void 0 : _data$overviewWorkedH2.length) !== 0 && (data === null || data === void 0 ? void 0 : (_data$overviewWorkedH3 = data.overviewWorkedHourDetails) === null || _data$overviewWorkedH3 === void 0 ? void 0 : (_data$overviewWorkedH4 = _data$overviewWorkedH3.userWorkDetails) === null || _data$overviewWorkedH4 === void 0 ? void 0 : _data$overviewWorkedH4.length) < WORK_HOUR_LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [data === null || data === void 0 ? void 0 : (_data$overviewWorkedH5 = data.overviewWorkedHourDetails) === null || _data$overviewWorkedH5 === void 0 ? void 0 : _data$overviewWorkedH5.userWorkDetails]);
  if (overviewUserWorkDetailsLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table-section"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "head-screenshot-card"
    }, /*#__PURE__*/React.createElement("span", {
      className: "head-website-lists"
    }, "Work Hours Summary")), /*#__PURE__*/React.createElement(Loader, null)));
  }
  if (overviewUserWorkDetailsError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!(data !== null && data !== void 0 && (_data$overviewWorkedH6 = data.overviewWorkedHourDetails) !== null && _data$overviewWorkedH6 !== void 0 && _data$overviewWorkedH6.userWorkDetails)) {
    return null;
  }

  //setOverviewUserDataFetch(false);

  function getCheckInType(checkInTime) {
    if (checkInTime == "-" || checkInTime == "0") {
      return "low";
    } else if (checkInTime <= "10:00") {
      return "highest";
    } else if (checkInTime >= "10:00" && checkInTime <= "11:00") {
      return "medium";
    } else if (checkInTime >= "11:00" && checkInTime <= "15:00") {
      return "average";
    }
    return "low";
  }
  var tableData = data === null || data === void 0 ? void 0 : (_data$overviewWorkedH7 = data.overviewWorkedHourDetails) === null || _data$overviewWorkedH7 === void 0 ? void 0 : _data$overviewWorkedH7.userWorkDetails.map(function (d) {
    var hoursWorked = d.hoursWorked,
      hoursWorkedType = d.hoursWorkedType,
      userName = d.userName,
      uniqueUrl = d.uniqueUrl;
    var checkInType = d.checkInType,
      checkInTime = d.checkInTime;

    //checkInTime = moment.unix(Number(checkInTime)).format("HH:MM");
    var checkInTimes = checkInTime == "0" || checkInTime == "-" ? "-" : moment.unix(Number(checkInTime)).format("hh:mm a");
    checkInType = getCheckInType(checkInTime);
    return {
      checkInType: checkInType,
      hoursWorked: hoursWorked,
      hoursWorkedType: hoursWorkedType,
      userName: userName,
      checkInTime: checkInTimes,
      uniqueUrl: uniqueUrl
    };
  });
  var handleLoadMore = function handleLoadMore() {
    var _data$overviewWorkedH8, _data$overviewWorkedH9;
    if (overviewUserWorkDetailsLoading) return;
    setIsLoadingMore(true);
    overviewWorkDataFetchMore({
      variables: {
        offset: data === null || data === void 0 ? void 0 : (_data$overviewWorkedH8 = data.overviewWorkedHourDetails) === null || _data$overviewWorkedH8 === void 0 ? void 0 : (_data$overviewWorkedH9 = _data$overviewWorkedH8.userWorkDetails) === null || _data$overviewWorkedH9 === void 0 ? void 0 : _data$overviewWorkedH9.length
      },
      updateQuery: function updateQuery(prev, _ref7) {
        var _fetchMoreResult$over6, _fetchMoreResult$over7, _fetchMoreResult$over8, _fetchMoreResult$over9, _prev$overviewWorkedH, _fetchMoreResult$over10;
        var fetchMoreResult = _ref7.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$over6 = fetchMoreResult.overviewWorkedHourDetails) === null || _fetchMoreResult$over6 === void 0 ? void 0 : (_fetchMoreResult$over7 = _fetchMoreResult$over6.userWorkDetails) === null || _fetchMoreResult$over7 === void 0 ? void 0 : _fetchMoreResult$over7.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$over8 = fetchMoreResult.overviewWorkedHourDetails) === null || _fetchMoreResult$over8 === void 0 ? void 0 : (_fetchMoreResult$over9 = _fetchMoreResult$over8.userWorkDetails) === null || _fetchMoreResult$over9 === void 0 ? void 0 : _fetchMoreResult$over9.length) < CURRENTLY_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          overviewWorkedHourDetails: _objectSpread(_objectSpread({}, prev.overviewWorkedHourDetails), {}, {
            userWorkDetails: [].concat(_toConsumableArray((_prev$overviewWorkedH = prev.overviewWorkedHourDetails) === null || _prev$overviewWorkedH === void 0 ? void 0 : _prev$overviewWorkedH.userWorkDetails), _toConsumableArray((_fetchMoreResult$over10 = fetchMoreResult.overviewWorkedHourDetails) === null || _fetchMoreResult$over10 === void 0 ? void 0 : _fetchMoreResult$over10.userWorkDetails))
          })
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-section"
  }, /*#__PURE__*/React.createElement("div", null, (data === null || data === void 0 ? void 0 : (_data$overviewWorkedH10 = data.overviewWorkedHourDetails) === null || _data$overviewWorkedH10 === void 0 ? void 0 : _data$overviewWorkedH10.userWorkDetails.length) !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "head-screenshot-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "head-website-lists"
  }, "Work Hours Summary")), /*#__PURE__*/React.createElement(Tables, {
    columns: columns,
    data: tableData,
    Link: Link,
    linkProps: linkProps,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    overviewUserWorkDetailsLoading: overviewUserWorkDetailsLoading,
    handleLoadMore: handleLoadMore
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "head-website-lists"
  }, "Work Hours Summary"), /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found"))));
};
var Tables = function Tables(_ref8) {
  var columns = _ref8.columns,
    data = _ref8.data,
    Link = _ref8.Link,
    linkProps = _ref8.linkProps,
    isAllLoaded = _ref8.isAllLoaded,
    isLoadingMore = _ref8.isLoadingMore,
    overviewUserWorkDetailsLoading = _ref8.overviewUserWorkDetailsLoading,
    handleLoadMore = _ref8.handleLoadMore;
  var _useTable = useTable({
      columns: columns,
      data: data
    }, useSortBy),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-hours-table-wrap"
  }, /*#__PURE__*/React.createElement("table", _extends({}, getTableProps(), {
    responsive: true,
    borderless: true,
    className: "dashboard-hours-table"
  }), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      // if (column.id === "hoursWorked") {
      //   return null;
      // }
      return (
        /*#__PURE__*/
        // Add the sorting props to control sorting. For this example
        // we can add them into the header props
        React.createElement("th", _extends({}, column.getHeaderProps(column.getSortByToggleProps()), {
          // colSpan={column.id === "hoursWorkedPercentage" ? 2 : 1}
          className: "dashboard-hours-thead-".concat(column.id)
        }), column.render("Header"), /*#__PURE__*/React.createElement("span", null, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(HiChevronUp, {
          className: "app-usage-datas-thead-sort-icon"
        }) : /*#__PURE__*/React.createElement(HiChevronDown, {
          className: "app-usage-datas-thead-sort-icon"
        }) : /*#__PURE__*/React.createElement(HiOutlineSelector, {
          className: "app-usage-datas-thead-sort-icon"
        })))
      );
    }));
  })), /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/React.createElement("td", _extends({
        className: "".concat(cell.column.id === "hoursWorked" ? "worked-data-td-".concat(cell.row.original.hoursWorkedType, " worked-data-hours-worked-td") : cell.column.id === "checkInTime" ? "worked-data-td-".concat(cell.row.original.checkInType) : cell.column.id === "productivePercentage" ? "worked-data-td-".concat(cell.row.original.productiveType) : "")
      }, cell.getCellProps()), cell.column.id === "userName" ? /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(cell.row.original.uniqueUrl)), {
        key: "risk-".concat(cell.row.original.uniqueUrl)
      }), cell.render("Cell")) : cell.render("Cell"));
    }));
  }))), !overviewUserWorkDetailsLoading && data && data.length != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "overview-work-hour-data-load-more"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users")) : null);
};
export default Dashboard;